/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_FullInputs */

const en_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event full`)
};

const es_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento lleno`)
};

const de_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung ausgebucht`)
};

const zh_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动已满`)
};

const ar_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفعالية مكتملة`)
};

const fr_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement complet`)
};

const vi_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện đã đầy`)
};

const sw_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukio limejaa`)
};

const th_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรมเต็มแล้ว`)
};

const bs_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Događaj je popunjen`)
};

const ja_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`満員`)
};

const ko_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정원 마감`)
};

const pt_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento lotado`)
};

const it_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento completo`)
};

const sv_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenemanget är fullt`)
};

const nl_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement vol`)
};

const da_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrangementet er fuldt`)
};

const nb_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrangementet er fullt`)
};

const fi_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapahtuma on täynnä`)
};

const pl_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak miejsc`)
};

const ru_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мест нет`)
};

const tr_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik dolu`)
};

const hi_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम भर चुका है`)
};

const id_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara penuh`)
};

const ms_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara penuh`)
};

const cs_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce je obsazena`)
};

const el_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η εκδήλωση είναι πλήρης`)
};

const he_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אירוע מלא`)
};

const af_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleentheid is vol`)
};

const hu_events_full = /** @type {(inputs: Events_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az esemény betelt`)
};

/**
* | output |
* | --- |
* | "Event full" |
*
* @param {Events_FullInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_full = /** @type {((inputs?: Events_FullInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_FullInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_full(inputs)
	if (locale === "de") return de_events_full(inputs)
	if (locale === "zh") return zh_events_full(inputs)
	if (locale === "ar") return ar_events_full(inputs)
	if (locale === "fr") return fr_events_full(inputs)
	if (locale === "vi") return vi_events_full(inputs)
	if (locale === "sw") return sw_events_full(inputs)
	if (locale === "th") return th_events_full(inputs)
	if (locale === "bs") return bs_events_full(inputs)
	if (locale === "ja") return ja_events_full(inputs)
	if (locale === "ko") return ko_events_full(inputs)
	if (locale === "pt") return pt_events_full(inputs)
	if (locale === "it") return it_events_full(inputs)
	if (locale === "sv") return sv_events_full(inputs)
	if (locale === "nl") return nl_events_full(inputs)
	if (locale === "da") return da_events_full(inputs)
	if (locale === "nb") return nb_events_full(inputs)
	if (locale === "fi") return fi_events_full(inputs)
	if (locale === "pl") return pl_events_full(inputs)
	if (locale === "ru") return ru_events_full(inputs)
	if (locale === "tr") return tr_events_full(inputs)
	if (locale === "hi") return hi_events_full(inputs)
	if (locale === "id") return id_events_full(inputs)
	if (locale === "ms") return ms_events_full(inputs)
	if (locale === "cs") return cs_events_full(inputs)
	if (locale === "el") return el_events_full(inputs)
	if (locale === "he") return he_events_full(inputs)
	if (locale === "af") return af_events_full(inputs)
	if (locale === "hu") return hu_events_full(inputs)
	return en_events_full(inputs)
});